import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../services/api";
export default function DownloadsPage() {
  const [items, setItems] = useState<any[]>([]),
    [error, setError] = useState("");
  useEffect(() => {
    apiFetch("/api/export/history")
      .then(async (r) => {
        if (!r.ok) throw new Error();
        setItems((await r.json()).downloads);
      })
      .catch(() => setError("Unable to load download history."));
  }, []);
  return (
    <>
      <div className="page-title">
        <div>
          <span className="eyebrow">READY FOR YOUR NEXT STEP</span>
          <h1>Downloads</h1>
          <p>
            Your recent CSV exports. Downloading unlocked contacts costs no
            extra credits.
          </p>
        </div>
        <Link className="button button-dark" to="/my-leads">
          Export contacts ↓
        </Link>
      </div>
      {error && (
        <p className="notice error" role="alert">
          {error}
        </p>
      )}
      <section className="panel">
        {items.length ? (
          items.map((item) => (
            <div className="download-row" key={item.id}>
              <span className="stat-icon">↓</span>
              <div>
                <strong>ReachAtlas contact export</strong>
                <small>
                  {new Date(item.created_at + "Z").toLocaleString()} ·{" "}
                  {item.row_count.toLocaleString()} contacts
                </small>
              </div>
              <span className="data-badge good">CSV</span>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <span>↓</span>
            <h2>Take your shortlist with you.</h2>
            <p>
              Export unlocked contacts from My lists. Your download history will
              appear here.
            </p>
            <Link to="/my-leads">Open My lists →</Link>
          </div>
        )}
        <p className="fine-print">
          Files download directly to your device. To create a fresh export,
          return to My lists.
        </p>
      </section>
    </>
  );
}
